var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiJsonDataIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 31,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 31,
    rx: 4.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7134 14.1281L27.4668 14.6938C27.2864 15.1079 26.7136 15.1079 26.5331 14.6938L26.2866 14.1281C25.8471 13.1195 25.0555 12.3164 24.0677 11.8771L23.308 11.5392C22.8973 11.3565 22.8973 10.7588 23.308 10.5761L24.0252 10.2571C25.0384 9.80651 25.8442 8.97373 26.2761 7.93083L26.5293 7.31953C26.7058 6.89349 27.2942 6.89349 27.4706 7.31953L27.7238 7.93083C28.1558 8.97373 28.9616 9.80651 29.9748 10.2571L30.6919 10.5761C31.1027 10.7588 31.1027 11.3565 30.6919 11.5392L29.9323 11.8771C28.9445 12.3164 28.1529 13.1195 27.7134 14.1281ZM12.8284 16.0001L17.0711 20.2428L15.6568 21.657L10 16.0001L15.6568 10.3433L17.0711 11.7575L12.8284 16.0001ZM28.3429 21.6572L33.9998 16.0003L31.1714 13.1719L29.7571 14.5861L31.1714 16.0003L26.9287 20.2429L28.3429 21.6572Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiJsonDataIconV2);
export default __webpack_public_path__ + "static/media/AIJsonDataIconV2.1a9d7cb9.svg";
export { ForwardRef as ReactComponent };